/**
 * Main JavaScript entry point
 *
 * This imports all necessary modules and styles
 */

// Import main stylesheet
import "../scss/style.scss";

// Import Lenis for smooth scrolling
import Lenis from "@studio-freight/lenis";

// Import custom modules
import initMobileNav from "./modules/mobile-nav";
import initSliders from "./modules/sliders";
import initTabs from "./modules/tabs";
import initAnimations from "./modules/gsap-animations";

// DOM ready
document.addEventListener("DOMContentLoaded", function () {
  // Initialize Lenis smooth scrolling
  const lenis = initLenis();
  // Make lenis available globally for other modules
  window.lenis = lenis;

  // Initialize modules
  initMobileNav();
  initSliders();
  initTabs();
  initAnimations();
  // Add your other JavaScript here
});

/**
 * Initialize Lenis smooth scrolling
 */
function initLenis() {
  // Initialize Lenis with options
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    direction: "vertical",
    gestureDirection: "vertical",
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  });

  // Get all links that hash
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      // Get the target element
      const targetId = this.getAttribute("href");
      if (targetId === "#") return;

      // Scroll to the target
      lenis.scrollTo(targetId);
    });
  });

  // Connect lenis to RAF (request animation frame)
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // Optional: connect lenis to scroll events to update scroll trigger animations if using GSAP
  lenis.on("scroll", (e) => {
    // console.log(e);
  });

  // Add data attributes to body for potential styling during smooth scrolling
  function lenisStyles() {
    if (lenis.isStopped) {
      document.body.setAttribute("data-lenis-stopped", "");
    } else {
      document.body.removeAttribute("data-lenis-stopped");
    }

    if (lenis.isScrolling) {
      document.body.setAttribute("data-lenis-scrolling", "");
    } else {
      document.body.removeAttribute("data-lenis-scrolling");
    }

    if (lenis.direction === 1) {
      document.body.setAttribute("data-lenis-scrolling-down", "");
      document.body.removeAttribute("data-lenis-scrolling-up");
    } else if (lenis.direction === -1) {
      document.body.setAttribute("data-lenis-scrolling-up", "");
      document.body.removeAttribute("data-lenis-scrolling-down");
    }
  }

  lenis.on("scroll", lenisStyles);
  return lenis;
}
